import * as React from "react";
import { BoxSelect } from "../SharedReact/BasicElements";
import { ErrorModal } from "../SharedReact/Modal";
export class MetadataEditBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            numerator: this.props.numerator.toString(),
            denominator: this.props.denominator,
            bpm: this.props.bpm.toString(),
            modalShown: false, errorString: ""
        };
        this.handleNumeratorChange = this.handleNumeratorChange.bind(this);
        this.handleNumeratorBlur = this.handleNumeratorBlur.bind(this);
        this.handleDenominatorChange = this.handleDenominatorChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleNumeratorChange(value) {
        this.setState({ numerator: value });
    }
    handleNumeratorBlur(value) {
        let newNumerator = parseInt(value, 10);
        if (Number.isNaN(newNumerator) || newNumerator <= 0 || newNumerator > 32) {
            this.setState({ numerator: this.props.numerator, modalShown: true, errorString: "Invalid numerator value - please enter a number between 1 and 32." });
        }
        else {
            this.setState({ numerator: newNumerator });
        }
    }
    handleDenominatorChange(value) {
        let intValue = parseInt(value, 10);
        this.setState({ denominator: intValue });
    }
    handleBPMChange(value) {
        this.setState({ bpm: value });
    }
    handleBPMBlur(value) {
        let newBpm = parseInt(value, 10);
        if (Number.isNaN(newBpm) || newBpm <= 0 || newBpm > 300) {
            this.setState({ bpm: this.props.bpm, modalShown: true, errorString: "Invalid BPM value - please enter a number between 1 and 300." });
        }
        else {
            this.setState({ bpm: newBpm });
        }
    }
    handleSubmit() {
        if (!this.state.modalShown) {
            let newNumerator = parseInt(this.state.numerator);
            let newBpm = parseInt(this.state.bpm);
            this.props.onSubmit(newNumerator, this.state.denominator, newBpm);
        }
    }
    render() {
        return React.createElement("div", { className: "metadataDiv" },
            React.createElement("div", { className: "boxSelectOverlayArrow top" }),
            React.createElement("div", { className: "metadataInnerDiv" },
                React.createElement("div", { className: "metadataProperty" },
                    React.createElement("p", null, "Time Signature:"),
                    React.createElement(TimeSignatureEditBox, { numerator: this.state.numerator, onNumeratorBlur: (value) => { this.handleNumeratorBlur(value); }, onNumeratorChange: this.handleNumeratorChange, denominator: this.state.denominator, onDenominatorChange: this.handleDenominatorChange })),
                React.createElement("div", { className: "metadataProperty" },
                    React.createElement("p", null, "BPM:"),
                    React.createElement("input", { className: "metadataBPM", type: "text", size: 2, value: this.state.bpm, pattern: "[0-9]*", onBlur: (event) => { this.handleBPMBlur(event.target.value); }, onChange: (event) => { this.handleBPMChange(event.target.value); } })),
                React.createElement("button", { className: "metadataSubmit", onClick: this.handleSubmit }, "Submit")),
            this.state.modalShown && React.createElement(ErrorModal, { error: this.state.errorString, onClose: () => this.setState({ modalShown: false }) }));
    }
}
class TimeSignatureEditBox extends React.Component {
    render() {
        var containerStyle = { display: "inline-block" };
        return React.createElement("div", { className: "metadataTimeSignature", style: containerStyle },
            React.createElement("input", { className: "metadataNumerator", type: "text", value: this.props.numerator, onBlur: (event) => { this.props.onNumeratorBlur(event.target.value); }, onChange: (event) => { this.props.onNumeratorChange(event.target.value); } }),
            React.createElement("div", { className: "metadataDivider" }),
            React.createElement(BoxSelect, { mainButtonClassName: "metadataDenominator buttonAnim", boxSelectTitle: this.props.denominator.toString(), options: TimeSignatureEditBox.timeSignatureStrings, selectedCallback: (value) => { this.props.onDenominatorChange(TimeSignatureEditBox.timeSignatureNumbers[value]); } }));
    }
}
TimeSignatureEditBox.timeSignatureStrings = ["2", "4", "8", "16", "32"];
TimeSignatureEditBox.timeSignatureNumbers = [2, 4, 8, 16, 32];
//# sourceMappingURL=MetadataEditBox.js.map